import ConfigPreview from './ConfigPreview'
import Data from './Data'
import Editing from './Editing'
import Execution from './Execution'
import Management from './Management'

export default [...ConfigPreview, ...Data, ...Editing, ...Execution, ...Management]
